module.exports = __webpack_public_path__ + "img/text-11.34a71133.png";